/* import __COLOCATED_TEMPLATE__ from './care-recipient-selector.hbs'; */
import Component from '@glimmer/component';
import styles from './care-recipient-selector.module.scss';

export default class RequestPrescreenerInformationCareRecipientSelector extends Component {
  styles = styles;
}
